import DefaultSettingsAPI from '@/app/apis/main/default-settings/default-settings-api.js';

export default {
	/**
	 * @returns {object} default settings
	 * @param queryParams
	 */
	async getDefaultSettings(queryParams) {
		return DefaultSettingsAPI.getDefaultSettings(queryParams);
	}
};